export default __webpack_public_path__ + "static/media/trash.7b1a658c.svg";